import React from "react";
import "./Template_3.css";

const Template_3_Reviews = () => {
  const testimonials = [
    {
      text: "The bespoke Maldives retreat exceeded all expectations. Impeccable service and unparalleled privacy.",
      author: "Elizabeth Windsor",
      role: "Luxury Traveler",
      image: "https://randomuser.me/api/portraits/women/12.jpg",
      rating: 5,
    },
    {
      text: "Our family sojourn to Tuscany was masterfully orchestrated. Cultural depth with modern luxury.",
      author: "Alexander Romanov",
      role: "Family Patron",
      image: "https://randomuser.me/api/portraits/men/45.jpg",
      rating: 5,
    },
    {
      text: "The spiritual odyssey to Bhutan was transformative. Authentic experiences with refined comfort.",
      author: "Sophia Loren",
      role: "Cultural Enthusiast",
      image: "https://randomuser.me/api/portraits/women/78.jpg",
      rating: 4.5,
    },
  ];

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star"></i>);
    }

    if (hasHalfStar) {
      stars.push(<i key="half" className="fas fa-star-half-alt"></i>);
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={`empty-${i}`} className="far fa-star"></i>);
    }

    return stars;
  };

  return (
    <section
      id="reviews"
      className="Template_3 section Template_3 testimonials"
    >
      <div className="Template_3 container">
        <div className="Template_3 section-title">
          <h2>Client Testimonials</h2>
          <p>Reflections from our distinguished guests</p>
        </div>
        <div className="Template_3 testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="Template_3 testimonial-card">
              <div className="Template_3 testimonial-text">
                <p>{testimonial.text}</p>
              </div>
              <div className="Template_3 testimonial-author">
                <img src={testimonial.image} alt={testimonial.author} />
                <div>
                  <h4>{testimonial.author}</h4>
                  <p>{testimonial.role}</p>
                  <div className="Template_3 testimonial-rating">
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Template_3_Reviews;
